/* eslint-disable no-magic-numbers */

export interface IMapPayload {
  office_id: number;
  from_date: string;
  to_date: string;
}

export interface IMapResponse {
  booking_data: IMapWorkstation[];
  map_squares: IMapZoneArea[];
}

export interface IMapZoneArea {
  office_zone_id: number;
  grid_area: string; // for frontend use
  color: string;
  map_x: number;
  map_y: number;
}

export interface IMapWorkstation {
  workstation_type_id: EWorkstationType | null;
  dic_office_zone_id: number | null;
  price_per_hour: string | null;
  object_type_id: number;
  dic_office_id: number;
  is_available: boolean;
  is_selected: boolean; // for frontend use
  num: number | null;
  grid_area: string; // for frontend use
  angle: number;
  map_x: number;
  map_y: number;
  id: number;
}

export enum EWorkstationType {
  PC = 1,
  Console = 5,
}

export enum EMapElement {
  Extinguisher = 'extinguisher',
  TableFootball = 'football',
  ArrowExit = 'arrow-exit',
  Reception = 'reception',
  PingPong = 'ping-pong',
  Billiard = 'billiard',
  Hookah = 'hookah',
  Corner = 'corner',
  WallT = 'wall-t',
  WallX = 'wall-x',
  Empty = 'empty',
  Sofa = 'sofa',
  Wall = 'wall',
  Car = 'wheel',
  Bar = 'bar',
  Vr = 'vr',
  Wc = 'wc',
}

export const MAP_OBJECTS_TYPE = new Map([
  [1, EMapElement.Wall],
  [2, EMapElement.ArrowExit],
  [3, EMapElement.Sofa],
  [4, EMapElement.Extinguisher],
  [5, EMapElement.Wc],
  [6, EMapElement.Bar],
  [7, EMapElement.Reception],
  [8, EMapElement.Hookah],
  [9, EMapElement.Vr],
  [10, EMapElement.TableFootball],
  [11, EMapElement.PingPong],
  [12, EMapElement.Billiard],
  [13, EMapElement.Corner],
  [14, EMapElement.WallT],
  [15, EMapElement.WallX],
  [16, EMapElement.Car],
]);

export interface IMapSocketData {
  is_available: boolean;
  map_x: number;
  map_y: number;
  price_per_hour: string;
  workstation_id: number;
}
